import moment from 'moment';

export const getUploadedTime = dateString => {
	const today = moment();
	const momentDate = moment(dateString);

	return momentDate.isSame(today, 'day')
		? `at ${momentDate.format('h:mma')} today`
		: `at ${momentDate.format('h:mma')} on ${momentDate.format('MMM D YYYY')}`;
};
